/* eslint-disable max-len */
import { LOCALES } from 'i18n/locales';

export const reaffirmationPageIntl = {
    [LOCALES.ENGLISH]: {
        'reaffirmationPage.title': 'Reaffirmation',
        'reaffirmationPage.message.success.200.confirm': 'Your email address has been confirmed. You may continue to use the NUAR service.',
        'reaffirmationPage.message.success.403.confirm': 'Your email address has already been confirmed. No further action is required.',
        'reaffirmationPage.message.title': 'Success',
        'reaffirmationPage.message.button': 'Continue'
    },
    [LOCALES.WELSH]: {
        'reaffirmationPage.title': 'Ailgadarnhau',
        'reaffirmationPage.message.success.200.confirm': 'Mae\'ch cyfeiriad e-bost wedi cael ei gadarnhau. Gallwch barhau i ddefnyddio\'r gwasanaeth NUAR.',
        'reaffirmationPage.message.success.403.confirm': 'Mae\'ch cyfeiriad e-bost wedi cael ei gadarnhau eisoes. Nid oes rhagor o weithredu yn ofynnol.',
        'reaffirmationPage.message.title': 'Llwyddiant',
        'reaffirmationPage.message.button': 'Parhau'
    }
};
